export default "__VITE_ASSET__Bf55TSad__"